import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Generador SVG de Código de Barras estándar (Codificación visual 1D limpia y escalable)
 */
const CodigoBarras = ({ valor = '', ancho = 2, alto = 50, mostrarTexto = true, fontSize = 12 }) => {
    const barras = useMemo(() => {
        if (!valor) return [];

        // Generar un patrón determinista de anchos de barras a partir de los caracteres
        const chars = String(valor).trim();
        const pattern = [];

        // Barra de inicio (guard pattern)
        pattern.push(2, 1, 2, 1);

        for (let i = 0; i < chars.length; i++) {
            const code = chars.charCodeAt(i);
            // Generar 4 barras/espacios según el valor del caracter
            const b1 = (code % 3) + 1;
            const s1 = ((code >> 1) % 2) + 1;
            const b2 = ((code >> 2) % 3) + 1;
            const s2 = ((code >> 3) % 2) + 1;
            pattern.push(b1, s1, b2, s2);
        }

        // Barra de fin (guard pattern)
        pattern.push(2, 1, 2);

        // Convertir patrón a rectángulos SVG
        let posX = 10;
        const rects = [];
        for (let i = 0; i < pattern.length; i++) {
            const w = pattern[i] * ancho;
            if (i % 2 === 0) {
                // Barra negra
                rects.push({ x: posX, width: w });
            }
            posX += w;
        }

        return { rects, totalWidth: posX + 10 };
    }, [valor, ancho]);

    if (!valor) return null;

    return (
        <Box sx={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', bgcolor: '#fff', p: 1, borderRadius: 1 }}>
            <svg
                width={barras.totalWidth}
                height={alto}
                viewBox={`0 0 ${barras.totalWidth} ${alto}`}
                style={{ display: 'block' }}
            >
                {barras.rects.map((r, idx) => (
                    <rect key={idx} x={r.x} y={0} width={r.width} height={alto} fill="#111827" />
                ))}
            </svg>
            {mostrarTexto && (
                <Typography
                    variant="caption"
                    sx={{
                        fontFamily: 'monospace',
                        fontWeight: 'bold',
                        letterSpacing: 2,
                        color: '#1f2937',
                        mt: 0.5,
                        fontSize
                    }}
                >
                    {valor}
                </Typography>
            )}
        </Box>
    );
};

export default CodigoBarras;
